import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import {StyleAttributeImm} from '@packages/systems/wfdl';
import {Map} from 'immutable';
import {OPTIMIZE_CLICK_TRACKING_ATTR_NAME} from '@packages/utilities/platform';

export const maybeAddEventTrackingAttribute = (
  runtimeEnvironment: Environment,
  optimizationClickMode: boolean
) => {
  return (
    attributes: Map<string, string | StyleAttributeImm | Map<string, string>>
  ) => {
    if (
      optimizationClickMode &&
      runtimeEnvironment === WebflowEnvironments.DESIGNER
    ) {
      return attributes.set(OPTIMIZE_CLICK_TRACKING_ATTR_NAME, '');
    }
    return attributes;
  };
};
